import { useState, useContext } from "react";
import { TextField, Box, Typography } from "@mui/material";
import { RetornoLoteContext } from "../../Context/RetornoLoteContext";

export default function InputJustificativa({ justificativa, id, disabled }) {
  const { setGlosas, setJustificativa } = useContext(RetornoLoteContext);

  const [justificativaAtual, setJustificativaAtual] = useState(justificativa);

  const alteraJustificativa = (valor) => {
    setGlosas((prevState) => {
      const novoJustificativa = prevState;
      const resultado = novoJustificativa.map((item) => {
        if (item.id === id) {
          return { ...item, justificativa: valor };
        }
        return { ...item };
      });

      return resultado;
    });
    setJustificativa(valor);
  };
  return (
    <Box>
      <Typography
        variant="subtitle2"
        sx={{
          mb: 0.5,
          color: "#757575",
          fontWeight: 600,
        }}
      >
        Justificativa
      </Typography>

      <TextField
        placeholder="Digite aqui..."
        variant="standard"
        fullWidth
        multiline
        minRows={2}
        disabled={disabled}
        InputProps={{
          disableUnderline: true,
        }}
        value={justificativaAtual}
        onChange={(e) => setJustificativaAtual(e.target.value)}
        onBlur={(e) => alteraJustificativa(e.target.value)}
        sx={{
          overflowY: "auto",
          maxHeight: "80px",
          backgroundColor: "rgba(255,255,255,0.9)",
          borderRadius: 1,
          border: "1px solid #ccc",
          "& .MuiInputBase-input": {
            padding: "6px 8px",
          },
          "& .MuiInputBase-root.Mui-disabled": {
            backgroundColor: "#f0f0f0",
            color: "#777",
            cursor: "not-allowed",
            "*": { cursor: "not-allowed !important" },
          },
        }}
      />
    </Box>
  );
}
